import React from "react";
//IMG imports
import eiffil from '../../static/media/eiffil.png' 
import goggles from '../../static/media/goggles.png'
import teddy  from '../../static/media/teddy.png'
import saturn from '../../static/media/saturn.png'

function RenderUtilityItem({data,styles}){

  const downloadFile = (url) => { 
    fetch(url, {
      method: 'GET',
      mode:'cors'
    })
    .then((response) => response.blob())
    .then((blob) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(
        new Blob([blob]),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `3D_model.jpg`,
      );
  
      // Append to html link element page
      document.body.appendChild(link);
  
      // Start download
      link.click();
  
      // Clean up and remove the link
      link.parentNode.removeChild(link);
    });
  
  }

   if(data.id === 2){
     return(
        <a key={data.id} onClick={(e) => alert('You must download our AR app!')}>
        <div key={data.id} className={styles.utility}>
          <div className={styles.utility_icon}>
            <img src={data.img_src} alt="" />
          </div>
          <div className={styles.utility_text}>
            <div className={styles.utility_heading}>{data.head}</div>
            <div className={styles.utility_subheading}>
              {data.sub_head}
            </div>
          </div>
        </div>
        </a>
     )
   }else if(data.id === 3){
     return(
      <a key={data.id} onClick={()=> downloadFile(data.url)}>
      <div  key={data.id} className={styles.utility}>
        <div className={styles.utility_icon}>
          <img src={data.img_src} alt="" />
        </div>
        <div className={styles.utility_text}>
          <div className={styles.utility_heading}>{data.head}</div>
          <div className={styles.utility_subheading}>
            {data.sub_head}
          </div>
        </div>
      </div>
      </a>
     )
   }else{
    return(
        <a key={data.id} href={data.url} key={data.id} target="_blank" rel='noopener' rel="noreferrer">
        <div key={data.id} className={styles.utility}>
          <div className={styles.utility_icon}>
            <img src={data.img_src} alt="" />
          </div>
          <div className={styles.utility_text}>
            <div className={styles.utility_heading}>{data.head}</div>
            <div className={styles.utility_subheading}>
              {data.sub_head}
            </div>
          </div>
        </div>
      </a>
    )
    }
}
function UtilitiesPanel({styles}) {
   let items = [
    {  
    id:1,      
    img_src:eiffil,
    head:'View on IPFS',
    sub_head:'Your NFT data stored safely forever',
    url:'https://ipfs.io/ipfs/QmcQ6pgjeAEa3m1ugL7YUJezCyH4zvUGXiZbTG3NoiLiPV'
   },
   {
    id:2,
    img_src:goggles,
    head:'View AR experience',
    sub_head:'See how your NFT looks in augmented reality',
    url:'#'
   },
   {
    id:3,
    img_src: teddy ,
    head:'Download 3D Model',
    sub_head:'Instantly get acccess to the blend file',
    url:'#'
   },
   {
    id: 4,
    img_src: saturn,
    head:'Join the community',
    sub_head:'Unlock Community access with your NFT',
    url:'https://discord.gg/polygon'
 }
]
  return (
    <div className={styles.utilities}>
      <div className={styles.utilities_container}>
       {items.map(item => <RenderUtilityItem data={item} styles={styles}/>)}
      </div>
    </div>
  );
}

export default UtilitiesPanel;
